import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { signIn } from '../../modules/user';
import { getUserDetails } from '../../modules/selectors';
import api from '../../utils/services';

// If location.state is passed, it must have the location in "from"
const propTypes = {
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.shape({
    state: PropTypes.shape({
      from: PropTypes.shape({
        pathname: PropTypes.string.isRequired,
      }).isRequired,
    }),
  }),
  user: PropTypes.shape({
    agentNpn: PropTypes.string,
    token: PropTypes.string,
    userId: PropTypes.string,
    userRole: PropTypes.string,
  }),
};
const defaultProps = {
  location: {},
  user: null,
};

function LoginRedirect(props) {
  const {
    location,
    ascendUser,
    dispatch,
    identityUser,
  } = props;
  if (identityUser) {
    const { user } = identityUser;
    if (user) {
      const { access_token: accessToken } = user;
      api.signInModified(accessToken)
        .then((data) => {
          if (data.errorMessage == null) {
            dispatch(signIn(data));
          }
        });
    }
    const { from } = location.state || { from: { pathname: '/' } };


    if (ascendUser) {
      return <Redirect to={from} />;
    }

    return <div>Redirecting...</div>;
  }
}

function mapStateToProps(state) {
  return {
    ascendUser: getUserDetails(state),
    identityUser: state.auth,
  };
}
LoginRedirect.propTypes = propTypes;
LoginRedirect.defaultProps = defaultProps;
export default connect(mapStateToProps)(LoginRedirect);
